import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';

// @ts-expect-error Could not find a declaration file for module
import useMediaQuery from 'LearningCenterUI/hooks/useMediaQuery';
import { device } from '../../../constants/StyledComponentConstants';
import { Pictogram } from 'foundations-components/transitional/components/Pictogram';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PracticalExerciseProgressFeedback = ({
  children,
  'data-test-id': dataTestId,
  pictogramName
}) => {
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    "data-test-id": dataTestId,
    flexDirection: isMobile ? 'column' : 'row',
    inlineSize: "100%",
    justifyContent: "center",
    minBlockSize: !isMobile ? '412px' : undefined,
    children: [/*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        justifyContent: "end",
        children: [/*#__PURE__*/_jsx(Pictogram, {
          blockSize: undefined,
          inlineSize: "200px",
          marginBlockEnd: isMobile ? '400' : undefined,
          name: pictogramName
        }), !isMobile && /*#__PURE__*/_jsx(View, {
          as: "span",
          blockSize: "320px",
          borderInlineEndColor: "border-core-subtle",
          borderInlineEndStyle: "solid",
          borderInlineEndWidth: "100",
          flexShrink: 0,
          marginInlineEnd: "1200",
          marginInlineStart: "800"
        })]
      })
    }), /*#__PURE__*/_jsx(Box, {
      children: children
    })]
  });
};
export default PracticalExerciseProgressFeedback;